class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Activate close button inside panel
    const closeButton = document.querySelector('.mobile-facets__close');
    const drawerDetails = document.querySelector('.mobile-facets__disclosure');
    if (closeButton && drawerDetails) {
      closeButton.addEventListener('click', () => {
        drawerDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-desktop');
      });
    }

    // Update sorting options on mobile
    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"][name="sort_by"]')) {
        const selectedLabel = event.target.closest('label')?.textContent.trim();
        const summaryText = this.querySelector('.sort-label');
        if (summaryText) {
          summaryText.textContent = selectedLabel;
        }
      }
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('.super-filter-input')) return;

      const input = event.target;
      const label = input.closest('.tag-filter-button');

      label.classList.toggle('active', input.checked);

      clearTimeout(input._debounce);
      input._debounce = setTimeout(() => {
        const form = document.getElementById('FacetFiltersFormMobile');
        const searchParams = FacetFiltersForm.prototype.createSearchParams.call(this, form);
        FacetFiltersForm.renderPage(searchParams, event);
      }, 300);
    });

    document.querySelectorAll('.super-filter-input').forEach((input) => {
      const urlParams = new URLSearchParams(window.location.search);
      const values = urlParams.getAll('filter.p.m.custom.super_filter');
      input.checked = values.includes(input.value);
      input.closest('.tag-filter-button').classList.toggle('active', input.checked);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    if (typeof initSwatches === 'function') initSwatches(document.getElementById('ProductGridContainer'));

    // Custom event to be triggered after filter interaction
    document.dispatchEvent(new CustomEvent('facet-filter-updated'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    requestAnimationFrame(() => {
      document.querySelectorAll('.price-slider').forEach((el) => {
        new PriceRange(el); // re-initialize
      });
    });

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();

    if (window.setupFiltersHelper) window.setupFiltersHelper();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    // Convert only the data you send to the URL (don't touch the inputs)
    const priceSlider = form.querySelector('.price-slider');
    if (priceSlider) {
      const minInput = priceSlider.querySelector('#min-price-range');
      const maxInput = priceSlider.querySelector('#max-price-range');

      if (minInput && maxInput) {
        const min = parseInt(minInput.value, 10);
        const max = parseInt(maxInput.value, 10);

        formData.set(minInput.name, Math.floor(min / 100));
        formData.set(maxInput.name, Math.ceil(max / 100));

        const minDefault = parseInt(minInput.getAttribute('min')) || 0;
        const maxDefault = parseInt(maxInput.getAttribute('max'));

        if (min <= minDefault && max >= maxDefault) {
          formData.delete(minInput.name);
          formData.delete(maxInput.name);
        }
      }
    }

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);

    if (event.target.matches('input[type="radio"][name="sort_by"]')) {
      // update only the sort_by param without removing filters
      urlParams.set('sort_by', event.target.value);

      const searchParams = urlParams.toString();
      this.onSubmitForm(searchParams, event);
    } else {
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      const searchParams = forms.join('&');
      this.onSubmitForm(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange {
  constructor(container) {
    this.container = container;
    this.minInput = container.querySelector('#min-price-range');
    this.maxInput = container.querySelector('#max-price-range');
    this.minDisplay = container.querySelector('#min-price-display');
    this.maxDisplay = container.querySelector('#max-price-display');
    this.rangeMax = parseInt(this.maxInput.getAttribute('max'), 10);

    if (!this.minInput || !this.maxInput) return;

    this.setValues();
    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    this.minInput.addEventListener('input', () => this.updateUI());
    this.maxInput.addEventListener('input', () => this.updateUI());
  }

  formatPrice(cents) {
    return (cents / 100).toLocaleString('en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  getURLValue(param) {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(param);
    return value ? parseInt(value) : null;
  }

  setValues() {
    const minUrl = this.getURLValue('filter.v.price.gte');
    const maxUrl = this.getURLValue('filter.v.price.lte');

    const defaultMin = parseInt(this.minInput.getAttribute('value')) || 0;
    const defaultMax = parseInt(this.maxInput.getAttribute('value')) || this.rangeMax;

    // ✅ Convert dollars from URL back to cents for slider
    this.minInput.value = minUrl !== null ? minUrl * 100 : defaultMin;
    this.maxInput.value = maxUrl !== null ? maxUrl * 100 : defaultMax;
  }

  updateUI() {
    const min = Math.min(this.minInput.valueAsNumber, this.maxInput.valueAsNumber);
    const max = Math.max(this.minInput.valueAsNumber, this.maxInput.valueAsNumber);

    this.minInput.value = min;
    this.maxInput.value = max;

    this.minDisplay.textContent = this.formatPrice(min);
    this.maxDisplay.textContent = this.formatPrice(max);

    this.minInput.parentElement.style.setProperty('--min', min);
    this.minInput.parentElement.style.setProperty('--maxv', max);
    this.minInput.parentElement.style.setProperty('--max', this.rangeMax);
  }
}

function setupPriceSliders() {
  document.querySelectorAll('.price-slider:not([data-initialized])').forEach((el) => {
    new PriceRange(el);
    el.setAttribute('data-initialized', 'true');
  });
}

document.addEventListener('DOMContentLoaded', setupPriceSliders);
document.addEventListener('facet-filters-updated', () => requestAnimationFrame(setupPriceSliders));

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
if (window.setupFiltersHelper) window.setupFiltersHelper();
